import { render, staticRenderFns } from "./ParticipantDetail.vue?vue&type=template&id=5bb9e08c"
import script from "./ParticipantDetail.vue?vue&type=script&lang=js"
export * from "./ParticipantDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports